import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_HTML_COMPONENTS_QUERY_KEY } from '@/state/queries/html-components/use-get-html-components';

export interface CreateHtmlComponentDto {
  name: string;
  html: string;
  version?: number;
  scope?: 'global';
}

export const useCreateHtmlComponentMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateHtmlComponentDto) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/html-components`;
      return sendJSONRequest({ url, method: METHOD.POST, body: data, token: token ?? undefined });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_HTML_COMPONENTS_QUERY_KEY] });
    },
  });
};
